import React from 'react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';

function AlumniStories({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page">
        <Reveal className="max-w-2xl">
          <span className="eyebrow"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          <p className="section-lead">
            <EditableText value={data.lead} onChange={(t) => update({ lead: t })} as="span" multiline />
          </p>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {items.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="group card-surface overflow-hidden h-full">
                <div className="h-56 overflow-hidden">
                  <EditableImage
                    src={s.image?.src}
                    alt={s.image?.alt || s.title}
                    onChange={(src, alt) => updateItem(i, { image: { src, alt } })}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-7">
                  <EditableText value={s.title} onChange={(t) => updateItem(i, { title: t })} as="h3" className="font-display text-2xl" />
                  <EditableText value={s.desc} onChange={(t) => updateItem(i, { desc: t })} as="p" multiline className="mt-3 text-ink/70 leading-relaxed" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AlumniStories;
